/* ===========================================================================
   woolberry — when the sticky "Select Size" bar appears.

   Stock behaviour (assets/cart-bar.js) reveals the bar as soon as you scroll
   past the add-to-cart form, which is very early on this PDP. We hold it back
   until the shopper has worked down the page.

   2026-09-12: it appears once the REVIEWS heading ("Your words, not ours.",
   snippets/wb-reviews-inline.liquid) scrolls into view. Same element on
   mobile (inside the buy column, under the accordions) and on desktop (the
   script in snippets/product.liquid moves that block under the product
   page) — it is the same node, so one selector covers both.

   History: last FAQ row (2026-08-23) → country selector → footer "Instagram"
   link (2026-08-27) → reviews heading (2026-09-12).

   cart-bar.js binds its scroll handler in the CONSTRUCTOR
   (this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this)),
   so patching the prototype afterwards would have no effect — the bound
   reference still points at the original. Instead we remove that exact
   listener (the instance keeps a reference to it) and install our own.

   Falls back to the stock "scrolled past the form" rule if the comparison
   block isn't on the page, so other products keep working.
   =========================================================================== */
(function () {
  var READABLE_INSET = 40; // px of the row that must be on screen to count

  /* 2026-09-12: the trigger is the reviews heading. The fallbacks below are
     the previous anchors, kept so a product without the reviews block (or a
     page where Judge.me has not rendered) still gets a sensible trigger
     instead of a stranded bar. */
  function faqAnchor() {
    var reviews = document.querySelector('.template-product [data-wb-reviews] .wb-rev__heading')
               || document.querySelector('.template-product [data-wb-reviews]');
    if (reviews) return reviews;

    var navLinks = document.querySelectorAll('.wb-fnl__nav a');
    for (var i = 0; i < navLinks.length; i++) {
      if ((navLinks[i].textContent || '').trim().toLowerCase() === 'instagram') {
        return navLinks[i];
      }
    }
    if (navLinks.length) return navLinks[navLinks.length - 1];

    var country = document.querySelector('.supporting-menu__item--localization');
    if (country) return country;

    var rows = document.querySelectorAll('.section-wb-accordion .wb-accordion__row');
    return rows[rows.length - 1]
        || document.querySelector('.wb-accordion__heading')
        || document.querySelector('.wb-accordion--plus');
  }

  function init() {
    if (window.wbCartbarTrigger === 'armed') return true; // never arm twice
    var bar = document.querySelector('cart-bar');
    if (!bar) return false;

    // drop the stock handler
    if (bar.boundToggleCartBarOnScroll) {
      document.removeEventListener('theme:scroll', bar.boundToggleCartBarOnScroll);
    }

    /* Removing that listener is not reliable on its own: whenDefined() can
       resolve before THIS instance upgrades, so the element may register its
       listener again after we removed it — measured 2026-08-27, the bar was
       still popping up at the stock position. The stock handler is
         if (this.formWrapper) { ...toggle('is-visible', scrolled past it) }
       so emptying formWrapper turns it into a no-op no matter when it runs.

       It has to be re-emptied on every pass, not once: the element's
       constructor assigns formWrapper, and if it upgrades after we run it
       simply puts the value back (observed live — the bar kept appearing at
       the FAQ). Capturing it here also preserves the reference our own
       fallback rule needs. */
    var formWrapper = null;

    function disarmStockHandler() {
      if (bar.formWrapper) {
        formWrapper = bar.formWrapper;
        bar.formWrapper = null;
      }
    }
    disarmStockHandler();

    /* The anchor is resolved once and reused (2026-09-12): update() runs on
       every scroll event, and faqAnchor() walks the footer links each time.
       It is looked up again only if the cached element left the DOM (section
       re-render). */
    var cachedRow = null;
    function anchor() {
      if (!cachedRow || !cachedRow.isConnected) cachedRow = faqAnchor();
      return cachedRow;
    }

    function update() {
      disarmStockHandler();
      var row = anchor();

      if (!row) {
        // no anchor on this page — keep the theme's original rule
        var fw = formWrapper;
        if (fw) {
          bar.classList.toggle('is-visible', window.scrollY > fw.offsetTop + fw.offsetHeight);
        }
        return;
      }

      var top = row.getBoundingClientRect().top;
      // show once the heading has scrolled up into readable view, and keep it
      // shown while the shopper is at or below that point
      bar.classList.toggle('is-visible', top <= window.innerHeight - READABLE_INSET);
    }

    /* one update per frame no matter how many scroll/theme:scroll events
       arrive in it (2026-09-12) */
    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      var tick = function () {
        ticking = false;
        update();
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(tick); else setTimeout(tick, 16);
    }
    document.addEventListener('theme:scroll', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();

    window.wbCartbarTrigger = 'armed'; // read in the browser to confirm this ran
    return true;
  }

  /* whenDefined('cart-bar') resolves when the CLASS is registered, which can be
     before this page's element is in the DOM — init() then found nothing, bailed
     out, and never tried again, leaving the theme's own rule in charge (that is
     why the bar kept appearing at its stock position on 2026-08-27). Retry on a
     short interval until the element exists, then arm once. */
  function boot() {
    if (init()) return;

    var tries = 0;
    var timer = setInterval(function () {
      if (init() || ++tries > 40) clearInterval(timer); // ~4s at 100ms
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
